"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onRadioClick = onRadioClick;
function onRadioClick(element) {
    var parent = element.closest('.form-element-validation');
    parent.classList.remove("error");
}